import styled from 'styled-components';
import {
    GameDetailsContainerDefaultBox
} from './game-details-container.default.box';



export const GameDetailsContainerCasino777Box = styled(GameDetailsContainerDefaultBox)`
  overflow: initial;
  &:after {
    background-size: 75%;
    opacity: .6;
    height: 15px;
    bottom:-15px;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
      bottom:-18px;
    }
  }
`